import React from "react";
import { IconProps, iconPropTypes } from "./IconProps";

const CastleIcon: React.FC<IconProps> = ({
  fill = "",
  width = 32,
  height = 32,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M25 3H24C23.4696 3 22.9609 3.21071 22.5858 3.58579C22.2107 3.96086 22 4.46957 22 5V7H18.5V5C18.5 4.46957 18.2893 3.96086 17.9142 3.58579C17.5392 3.21071 17.0304 3 16.5 3H15.5C14.9696 3 14.4609 3.21071 14.0858 3.58579C13.7107 3.96086 13.5 4.46957 13.5 5V7H10V5C10 4.46957 9.7893 3.96086 9.41422 3.58579C9.03915 3.21071 8.53044 3 8.00001 3H7.00001C6.46958 3 5.96087 3.21071 5.5858 3.58579C5.21072 3.96086 5.00001 4.46957 5.00001 5V10.5863C4.99917 10.849 5.05057 11.1093 5.15121 11.352C5.25185 11.5947 5.39973 11.815 5.58626 12L7.00001 13.4137V27C7.00001 27.5304 7.21072 28.0391 7.5858 28.4142C7.96087 28.7893 8.46958 29 9.00001 29H23C23.5304 29 24.0392 28.7893 24.4142 28.4142C24.7893 28.0391 25 27.5304 25 27V13.4137L26.4138 12C26.6003 11.815 26.7482 11.5947 26.8488 11.352C26.9495 11.1093 27.0008 10.849 27 10.5863V5C27 4.46957 26.7893 3.96086 26.4142 3.58579C26.0392 3.21071 25.5304 3 25 3ZM19 27H13V19C13 18.2044 13.3161 17.4413 13.8787 16.8787C14.4413 16.3161 15.2044 16 16 16C16.7957 16 17.5587 16.3161 18.1213 16.8787C18.6839 17.4413 19 18.2044 19 19V27Z" />
  </svg>
);

CastleIcon.propTypes = iconPropTypes;

export default CastleIcon;
